module.exports = __webpack_public_path__ + "img/guideBtn3.4f91a15b.png";